import React from "react";
import { Column, Row } from "../../../components/layout/flex-layout";
import { SpacingBox } from "../../../components/layout/spacing-box";
import { Typography } from "../../../components/typography/typography";
import { useQuotationPopupState } from "../../../hooks/use-app-state";
import { Separator } from "../../shared/separator";
import { QuotationPopupContactEmailField } from "./contact-email-field";
import { QuotationPopupContactNamesField } from "./contact-names-field";
import { QuotationPopupContactPhoneField } from "./contact-phone-field";
import { QuotationPopupDocumentNumberField } from "./document-number-field";
import { QuotationPopupDocumentTypeField } from "./document-type-field";
import { QuotationPopupFormContainer } from "./form-container";
import { QuotationPopupDocumentMonthlyAmount } from "./monthly-amount-field";
import { QuotationPopupDocumentRangeOfEmployees } from "./range-of-employees-field";
import { QuotationPopupSubmitButton } from "./submit-button";
import { QuotationPopupTermsAndConditionsCheckboxField } from "./terms-and-conditions-checkbox-field";
import { QuotationPopupValidAgeCheckboxField } from "./valid-age-checkbox-field";
import { QuotationPopupYesNoRadioField } from "./yes-no-radio-field";

export const QuotationPopupForm: React.FC = () => {
    const isDocumentValidByEquifax = useQuotationPopupState<boolean>([
        "form",
        "isDocumentValidByEquifax",
    ]);
    return (
        <div className="quotation-popup__form" data-testid="QuotationPopupForm">
            <SpacingBox mb={30} className="text-center">
                <Typography variant="secondary" fontSize={20}>
                    <b>
                        Indícanos tus datos para calcular la<br></br>mejor
                        propuesta para tu empresa
                    </b>
                </Typography>
            </SpacingBox>
            <QuotationPopupFormContainer>
                <Column>
                    <Row>
                        <QuotationPopupDocumentTypeField />
                        <QuotationPopupDocumentNumberField />
                    </Row>
                    <SpacingBox mb={18} />
                    <Separator />
                    <SpacingBox mb={18} />
                    {isDocumentValidByEquifax && (
                        <>
                            <QuotationPopupContactNamesField />
                            <SpacingBox mb={16} />
                            <Row>
                                <QuotationPopupContactPhoneField />
                                <SpacingBox mr={15} />
                                <QuotationPopupContactEmailField />
                            </Row>
                            <SpacingBox mb={18} />
                            <Separator />
                            <SpacingBox mb={18} />
                        </>
                    )}
                    <Row>
                        <QuotationPopupDocumentMonthlyAmount />
                        <SpacingBox mr={15} />
                        <QuotationPopupDocumentRangeOfEmployees />
                    </Row>
                    <SpacingBox mb={15} />
                    <QuotationPopupYesNoRadioField />
                    <SpacingBox mb={18} />
                    <Separator />
                    <SpacingBox mb={18} />
                    <QuotationPopupValidAgeCheckboxField />
                    <SpacingBox mb={16} />
                    <QuotationPopupTermsAndConditionsCheckboxField />
                    <SpacingBox mb={16} />
                    <QuotationPopupSubmitButton />
                </Column>
            </QuotationPopupFormContainer>
        </div>
    );
};
